"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_DELIVERY_FEES_TAX_ID = exports.V1_DELIVERY_FEES_TAX_NAME = void 0;
exports.v1ChargesDeliveryFees = v1ChargesDeliveryFees;
exports.v1DeliveryTax = v1DeliveryTax;
const errors_1 = require("../errors");
// Taxe des frais de livraison d'une commande v1 (R8). Partagée par la caisse
// et le serveur : les deux doivent résoudre la même taxe pour signer et
// recalculer la même ventilation.
exports.V1_DELIVERY_FEES_TAX_NAME = '20%';
exports.NO_DELIVERY_FEES_TAX_ID = 'delivery-tax-none';
// La zone peut-elle facturer quelque chose ? Une zone sans frais (ou à 0 €) ne
// produira aucun montant taxable.
function v1ChargesDeliveryFees(order) {
    const fees = order.deliveryZone?.fees;
    if (!fees)
        return false;
    return (fees.amount || 0) > 0 || (fees.reducedAmount || 0) > 0;
}
// La zone de livraison v1 ne porte pas de taxe : c'est la taxe « 20% » de la
// commande, et son absence est un refus quand des frais sont facturés.
function v1DeliveryTax(order) {
    const tax = (order.taxes || []).find((candidate) => candidate.name === exports.V1_DELIVERY_FEES_TAX_NAME);
    if (tax)
        return { id: tax._id, ratePercent: tax.rate };
    if (v1ChargesDeliveryFees(order)) {
        throw new errors_1.UnknownReferenceError(`frais de livraison : aucune taxe ${exports.V1_DELIVERY_FEES_TAX_NAME} dans la commande`);
    }
    // `fromV1Order` réclame une taxe pour TOUTE commande en livraison ; sans
    // frais, cette taxe neutre n'apparaît jamais dans la ventilation.
    return { id: exports.NO_DELIVERY_FEES_TAX_ID, ratePercent: 0 };
}
